export const new_money_transfer = `subscription new_money_transfer{
    new_money_transfer{
        transaction_code
        status
        from_account
        currency{
            currency
            name
            decimal
        }
        amount
        order_date
    }
}`;
